import * as React from "react";
import {
  Typography, Button, Chip, TextField, InputAdornment,
  FormControl, InputLabel, Select, MenuItem,
  ToggleButton, ToggleButtonGroup, Divider,
  Table, TableBody, TableCell, TableHead, TableRow, TablePagination, TableContainer,
  Checkbox, FormControlLabel, Collapse,
  Grid, Box, Paper, Stack
} from "../../components/mui";
import {
  SearchRoundedIcon, FilterAltRoundedIcon, RestartAltRoundedIcon,
  GetAppRoundedIcon, AddRoundedIcon, ApartmentRoundedIcon,
  ViewWeekRoundedIcon, ViewHeadlineRoundedIcon,
  ExpandMoreRoundedIcon, ExpandLessRoundedIcon
} from "../../components/icons";

import "../../styles/main.css";
import "../../styles/pages/condoUnits.css";
import PageLayout from "../../components/shared/PageLayout";
import PageHeader from "../../components/shared/PageHeader";
import DataTableCard from "../../components/shared/DataTableCard";
import CondoUnitFormModal from "./modals/AddCondoUnitModal";
import OccupantsHistoryModal from "./modals/OccupantsHistoryModal";

const COLUMN_OPTIONS = [
  { id: "column-unit", label: "Unit", defaultChecked: true },
  { id: "column-condo", label: "Condo", defaultChecked: true },
  { id: "column-lessee", label: "Lessee", defaultChecked: true },
  { id: "column-lessor", label: "Lessor", defaultChecked: true },
  { id: "column-capacity", label: "Capacity", defaultChecked: true },
  { id: "column-staff-occupants", label: "Staff occupants", defaultChecked: true },
  { id: "column-non-staff-occupants", label: "Non-staff occupants", defaultChecked: true },
  { id: "column-total-occupants", label: "Total occupants", defaultChecked: true },
  { id: "column-occupants-history", label: "Occupants history", defaultChecked: true },
  { id: "column-rental-fee", label: "Rental fee", defaultChecked: true },
  { id: "column-payment-term", label: "Payment term", defaultChecked: true },
  { id: "column-monthly-rent", label: "Monthly rent", defaultChecked: true },
  { id: "column-allowance", label: "Allowance", defaultChecked: false },
  { id: "column-active", label: "Active", defaultChecked: true },
  { id: "column-address", label: "Address", defaultChecked: true },
  { id: "column-location", label: "Location", defaultChecked: true },
  { id: "column-room-count", label: "Room count", defaultChecked: true },
  { id: "column-security-deposit", label: "Security deposit", defaultChecked: true },
  { id: "column-security-months", label: "Security months", defaultChecked: false },
  { id: "column-security-reference", label: "Security reference number", defaultChecked: false },
  { id: "column-security-receipt", label: "Security receipt date", defaultChecked: false },
  { id: "column-rental-start", label: "Rental start date", defaultChecked: false },
  { id: "column-rental-end", label: "Rental end date", defaultChecked: false },
  { id: "column-maid-name", label: "Maid name", defaultChecked: false },
  { id: "column-maid-contact", label: "Maid contact", defaultChecked: true },
  { id: "column-unit-phone", label: "Unit phone number", defaultChecked: false },
  { id: "column-unit-leader", label: "Unit leader", defaultChecked: false },
  { id: "column-account", label: "Account no", defaultChecked: false },
  { id: "column-advance-rental", label: "Advance rental payment", defaultChecked: false },
  { id: "column-advance-remaining", label: "Advance remaining balance", defaultChecked: false },
  { id: "column-advance-months", label: "Advance months", defaultChecked: false },
  { id: "column-advance-receipt", label: "Advance receipt date", defaultChecked: false },
  { id: "column-broker-name", label: "Broker name", defaultChecked: false },
  { id: "column-broker-email", label: "Broker email", defaultChecked: false },
  { id: "column-occupants-names", label: "Occupant's names", defaultChecked: true },
  { id: "column-condo-company", label: "Condo company", defaultChecked: true },
  { id: "column-condo-reference", label: "Condo reference number", defaultChecked: false },
  { id: "column-condo-sharing", label: "Condo sharing", defaultChecked: true },
  { id: "column-parking-slot", label: "Parking slot", defaultChecked: false },
  { id: "column-furnish-type", label: "Furnish type", defaultChecked: false }
];

const FILTER_MENU_PROPS = {
  PaperProps: {
    className: "condo-units-select-menu"
  },
  MenuListProps: {
    className: "condo-units-select-menu-list"
  }
};

const FILTERS = [
  {
    id: "filter-condo",
    label: "Condo",
    defaultValue: "all",
    options: [
      { value: "all", label: "All condos" },
      { value: "oriental", label: "Oriental KH" },
      { value: "141", label: "141 Apartment" }
    ]
  },
  {
    id: "filter-lessor",
    label: "Lessor",
    defaultValue: "all",
    options: [
      { value: "all", label: "All lessors" },
      { value: "jk", label: "JK" },
      { value: "141", label: "141" }
    ]
  },
  {
    id: "filter-condo-unit",
    label: "Condo Unit",
    defaultValue: "all",
    options: [
      { value: "all", label: "All units" },
      { value: "1a", label: "Tower 1 - A" },
      { value: "2b", label: "Tower 2 - B" }
    ]
  },
  {
    id: "filter-lessee",
    label: "Lessee",
    defaultValue: "all",
    options: [
      { value: "all", label: "All lessees" },
      { value: "corporate", label: "Corporate" },
      { value: "individual", label: "Individual" }
    ]
  },
  {
    id: "filter-payment-term",
    label: "Payment Term",
    defaultValue: "all",
    options: [
      { value: "all", label: "All terms" },
      { value: "monthly", label: "Monthly" },
      { value: "quarterly", label: "Quarterly" },
      { value: "semi-annual", label: "Semi-annual" }
    ]
  },
  {
    id: "filter-condo-company",
    label: "Condo Company",
    defaultValue: "none",
    options: [
      { value: "none", label: "None selected" },
      { value: "north", label: "North Holdings" },
      { value: "south", label: "South Estates" }
    ]
  },
  {
    id: "filter-active",
    label: "Active",
    defaultValue: "all",
    options: [
      { value: "all", label: "All" },
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" }
    ]
  },
  {
    id: "filter-condo-sharing",
    label: "Condo Sharing",
    defaultValue: "all",
    options: [
      { value: "all", label: "All" },
      { value: "allowed", label: "Allowed" },
      { value: "not-allowed", label: "Not allowed" }
    ]
  },
  {
    id: "filter-assigned",
    label: "Assigned",
    defaultValue: "all",
    options: [
      { value: "all", label: "All" },
      { value: "assigned", label: "Assigned" },
      { value: "unassigned", label: "Unassigned" }
    ]
  },
  {
    id: "filter-allowance",
    label: "Allowance",
    defaultValue: "all",
    options: [
      { value: "all", label: "All" },
      { value: "with", label: "With allowance" },
      { value: "without", label: "Without allowance" }
    ]
  }
];

const STATUS_COLOR = {
  Active: "success",
  Reserved: "primary",
  Vacant: "default"
};

const CONDO_UNIT_ROWS = [
  {
    id: "1003-oriental-active",
    unit: "1003 Oriental KH",
    condo: "Oriental KH",
    lessee: "JK",
    lessor: "O",
    capacity: 1,
    staffOccupants: 1,
    nonStaffOccupants: 0,
    totalOccupants: 1,
    rentalFee: "USD 3,600.00",
    paymentTerm: "6 months",
    monthlyRent: "USD 600.00",
    activeLabel: "Yes",
    activeStatus: STATUS_COLOR.Active,
    location: "Cambodia",
    roomCount: 1,
    occupantsNames: "(ID120) Handoyo, Caspo Inc, Operations Management, RB, Euro, Operations Analyst, Indonesian",
    hasDetailPage: true
  },
  {
    id: "1003-oriental-inactive",
    unit: "1003 Oriental KH",
    condo: "Oriental KH",
    lessee: "JK",
    lessor: "O",
    capacity: 1,
    staffOccupants: 1,
    nonStaffOccupants: 0,
    totalOccupants: 1,
    rentalFee: "USD 3,600.00",
    paymentTerm: "6 months",
    monthlyRent: "USD 600.00",
    activeLabel: "No",
    activeStatus: "error",
    location: "Cambodia",
    roomCount: 1,
    occupantsNames: "(ID120) Handoyo, Caspo Inc, Operations Management, RB, Euro, Operations Analyst, Indonesian",
    hasDetailPage: true
  },
  {
    id: "1003-oriental-active-2",
    unit: "1003 Oriental KH",
    condo: "Oriental KH",
    lessee: "JK",
    lessor: "O",
    capacity: 1,
    staffOccupants: 1,
    nonStaffOccupants: 0,
    totalOccupants: 1,
    rentalFee: "USD 3,600.00",
    paymentTerm: "6 months",
    monthlyRent: "USD 600.00",
    activeLabel: "Yes",
    activeStatus: STATUS_COLOR.Active,
    location: "Cambodia",
    roomCount: 1,
    occupantsNames: "(ID120) Handoyo, Caspo Inc, Operations Management, RB, Euro, Operations Analyst, Indonesian",
    hasDetailPage: true
  },
  {
    id: "1003-oriental-active-3",
    unit: "1003 Oriental KH",
    condo: "Oriental KH",
    lessee: "JK",
    lessor: "O",
    capacity: 1,
    staffOccupants: 1,
    nonStaffOccupants: 0,
    totalOccupants: 1,
    rentalFee: "USD 3,600.00",
    paymentTerm: "6 months",
    monthlyRent: "USD 600.00",
    activeLabel: "Yes",
    activeStatus: STATUS_COLOR.Active,
    location: "Cambodia",
    roomCount: 1,
    occupantsNames: "(ID120) Handoyo, Caspo Inc, Operations Management, RB, Euro, Operations Analyst, Indonesian",
    hasDetailPage: true
  }
];

/**
 * Condo Units Page Component
 * UI/Layout only - Backend developer will add:
 * - API calls for fetching condo units data
 * - Filter functionality
 * - Search functionality
 * - Pagination logic
 * - Column visibility state management
 * - Density toggle functionality
 * - Export functionality
 */
export default function CondoUnits({ onLogout, onNavigate }) {
  // Hardcoded data - Backend developer will replace with API calls and state management
  const employeeName = "Angelica Santos";
  const employeeId = "EMP-1042";
  const density = "comfortable";
  
  // Modal state - Backend dev will add proper state management
  const [columnSelectionOpen, setColumnSelectionOpen] = React.useState(false);
  const [addModalOpen, setAddModalOpen] = React.useState(false);
  const [occupantsHistoryModalOpen, setOccupantsHistoryModalOpen] = React.useState(false);
  const [selectedUnit, setSelectedUnit] = React.useState(null);

  const handleViewOccupantsHistory = (unitData) => {
    setSelectedUnit(unitData);
    setOccupantsHistoryModalOpen(true);
  };

  const handleNavigateToDetail = () => {
    if (typeof onNavigate === "function") {
      onNavigate({ key: "condo-unit-detail" });
    }
  };


  return (
    <PageLayout activeKey="condo-units" onLogout={onLogout} onNavigate={onNavigate} className="page-content">
          <PageHeader
            icon={ApartmentRoundedIcon}
            title="Condo Units"
            summary="Monitor inventory, leasing, and occupancy trends for every property."
            summaryExtra={
              <Box className="condo-units-summary">
                <Typography variant="body2" className="condo-units-summary-label">
                  Summary:
                </Typography>
                <Typography variant="body2" className="condo-units-summary-item">
                  <strong>Capacity</strong> 4
                </Typography>
                <Typography variant="body2" className="condo-units-summary-item">
                  <strong>Actual</strong> 2
                </Typography>
                <Typography variant="body2" className="condo-units-summary-item">
                  <strong>Available</strong> 2
                </Typography>
              </Box>
            }
            actions={
              <>
                <Button variant="outlined" startIcon={<RestartAltRoundedIcon />}>
                  Reset filters
                </Button>
                <Button variant="outlined" startIcon={<GetAppRoundedIcon />}>
                  Export
                </Button>
                <Button variant="contained" startIcon={<AddRoundedIcon />} onClick={() => setAddModalOpen(true)}>
                  Add condo unit
                </Button>
              </>
            }
          />

          <Paper elevation={0} className="content-box condo-units-toolbar" aria-label="Unit search and filters">
            <Box className="condo-units-filter-grid">
              {FILTERS.map(({ id, label, defaultValue, options }) => (
                <FormControl key={id} fullWidth size="small" className="condo-units-select">
                  <InputLabel id={id}>{label}</InputLabel>
                  <Select labelId={id} label={label} defaultValue={defaultValue} MenuProps={FILTER_MENU_PROPS}>
                    {options.map(({ value, label: optionLabel }) => (
                      <MenuItem key={value} value={value}>
                        {optionLabel}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ))}
            </Box>

            <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
              <Button
                variant="text"
                className="condo-units-toggle-columns"
                onClick={() => setColumnSelectionOpen((prev) => !prev)}
                endIcon={columnSelectionOpen ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
              >
                Column selection
              </Button>
            </Stack>

            <Collapse in={columnSelectionOpen} className="condo-units-columns">
              <Box className="condo-units-columns-grid">
                {COLUMN_OPTIONS.map(({ id, label, defaultChecked }) => (
                  <FormControlLabel
                    key={id}
                    control={<Checkbox defaultChecked={defaultChecked} color="primary" />}
                    label={label}
                  />
                ))}
              </Box>
            </Collapse>
          </Paper>

          <DataTableCard
            title="Condo Units List"
            showExport={false}
            totalEntries={7}
            startEntry={1}
            endEntry={7}
            currentPage={1}
            totalPages={1}
          >
            <TableContainer className={`data-table-wrapper data-table-wrapper--${density}`}>
              <Table size={density === "compact" ? "small" : "medium"} className="condo-units-table">
                <TableHead>
                  <TableRow>
                    <TableCell>Unit</TableCell>
                    <TableCell>Condo</TableCell>
                    <TableCell>Lessee</TableCell>
                    <TableCell>Lessor</TableCell>
                    <TableCell>Capacity</TableCell>
                    <TableCell>Staff occupants</TableCell>
                    <TableCell>Non-staff Occupants</TableCell>
                    <TableCell>Total Occupants</TableCell>
                    <TableCell className="action-cell">Occupants history</TableCell>
                    <TableCell>Rental fee</TableCell>
                    <TableCell>Payment term</TableCell>
                    <TableCell>Monthly rent</TableCell>
                    <TableCell>Active</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell>Room Count</TableCell>
                    <TableCell>Occupant's names</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {CONDO_UNIT_ROWS.map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell>
                        {row.hasDetailPage ? (
                          <Button
                            variant="text"
                            size="small"
                            className="condo-units-link-button"
                            onClick={handleNavigateToDetail}
                          >
                            {row.unit}
                          </Button>
                        ) : (
                          row.unit
                        )}
                      </TableCell>
                      <TableCell>{row.condo}</TableCell>
                      <TableCell>{row.lessee}</TableCell>
                      <TableCell>{row.lessor}</TableCell>
                      <TableCell align="right">{row.capacity}</TableCell>
                      <TableCell align="right">{row.staffOccupants}</TableCell>
                      <TableCell align="right">{row.nonStaffOccupants}</TableCell>
                      <TableCell>{row.totalOccupants}</TableCell>
                      <TableCell className="action-cell">
                        <Button
                          variant="text"
                          size="small"
                          className="condo-units-view-button"
                          onClick={() => handleViewOccupantsHistory({ unit: row.unit, condo: row.condo })}
                        >
                          View
                        </Button>
                      </TableCell>
                      <TableCell align="right">{row.rentalFee}</TableCell>
                      <TableCell align="right">{row.paymentTerm}</TableCell>
                      <TableCell align="right">{row.monthlyRent}</TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          label={row.activeLabel}
                          color={row.activeStatus || "default"}
                          className="condo-units-status-chip"
                        />
                      </TableCell>
                      <TableCell>{row.location}</TableCell>
                      <TableCell align="right">{row.roomCount}</TableCell>
                      <TableCell>{row.occupantsNames}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DataTableCard>

          {/* Add Condo Unit Modal */}
          <CondoUnitFormModal open={addModalOpen} onClose={() => setAddModalOpen(false)} />

          {/* Occupants History Modal */}
          <OccupantsHistoryModal
            open={occupantsHistoryModalOpen}
            onClose={() => setOccupantsHistoryModalOpen(false)}
            unitData={selectedUnit}
          />
    </PageLayout>
  );
}
